import request from '../../library/request';
import store from '../../store';
import setGlobalState from '../setGlobalState';

const getEid = () => store.getState().event.eid;

export const getCrmRecipients = async () => {
    const filter = store.getState().crm?.queryFilter || {};
    const freeFilter = store.getState().crm?.freeFilter || '';
    const status = store.getState().crm?.status || '';
    const res = await request('crm.getCrmRecipients', 'get', `/event/${getEid()}/crmRecipients`, {filter, freeFilter, status});
    setGlobalState('crm.crmRecipients', res.crmRecipients);
};

export const sendCrmMessage = async (type, data) => {
    const eid = getEid();
    const filter = store.getState().crm?.queryFilter || {};
    const freeFilter = store.getState().crm?.freeFilter || '';
    const status = store.getState().crm?.status || '';
    const res = await request('crm.sendCrmMessage', 'post', `/event/${eid}/crmMessage`, {filter, freeFilter, status, channel: type, ...data});
    return res;
};

export const getCrmWhatsappTemplate = async () => {
    const res = await request('crm.getCrmWhatsappTemplate', 'get', `/event/${getEid()}/whatsappTemplate`, {type: 'crm'});
    if(res?.whatsappMessage)
        setGlobalState('crm.crmWhatsappTemplate', res.whatsappMessage);
};

export const getSuspendedOrders = async () => {
    const filter = store.getState().crm?.queryFilter || {};
    const freeFilter = store.getState().crm?.freeFilter || '';
    const res = await request('crm.getSuspendedOrders', 'get', `/event/${getEid()}/suspendedOrders`, {filter, freeFilter});
    setGlobalState('crm.suspendedOrders', res.suspendedOrders);
};

export const sendConfirmations = async (data) => {
    const eid = getEid();
    const filter = store.getState().crm?.queryFilter || {};
    const freeFilter = store.getState().crm?.freeFilter || '';
    await request('crm.sendConfirmations', 'post', `/event/${eid}/sendConfirmations`, {filter, freeFilter, ...data});
};

